/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Uploading_To_ConnectInputs */



/**
* | output |
* | --- |
* | "Uploading to Connect..." |
*
* @param {Ateliere_Connect_Status_Uploading_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_uploading_to_connect = /** @type {((inputs?: Ateliere_Connect_Status_Uploading_To_ConnectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Uploading_To_ConnectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement vers Connect...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento su Connect...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка в Connect...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subiendo a Connect...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在上传到 Connect...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Connect にアップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्ट पर अपलोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando...")
	return /** @type {LocalizedString} */ ("Uploading to Connect...")
});